import { memo } from "react";
import { pdfjs, Page, Document } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const options = {
  cMapUrl: "https://unpkg.com/pdfjs-dist@3.11.174/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
  cMapPacked: true,
};

const PdfView = memo(({ src, size }: { src?: string; size?: number }) => {
  if (!src) return null;

  return (
    <Document file={src} loading={<div className="h-84 w-84" />} options={options}>
      <Page pageNumber={1} width={size} height={size} loading="" scale={1} renderAnnotationLayer={false} />
    </Document>
  );
});

PdfView.displayName = "PdfView";

export default PdfView;
